import {Component, OnInit} from '@angular/core';
import dashboardIcon from '@iconify/icons-mdi/view-dashboard-outline';
import listIcon from '@iconify/icons-mdi/view-list-outline';
import reportIcon from '@iconify/icons-mdi/chart-areaspline';
import {TransportInterventionsNavigationService} from './transport-interventions-navigation.service';

@Component({
  selector: 'app-transport-interventions-navigation',
  templateUrl: './transport-interventions-navigation.component.html',
  styleUrls: ['./transport-interventions-navigation.component.scss']
})
export class TransportInterventionsNavigationComponent implements OnInit {

  menu = [];
  current;
  text: string;
  icon: string;
  useSelectMode = true;

  constructor(private service: TransportInterventionsNavigationService) {
  }

  ngOnInit(): void {
    this.menu = this.service.menu;
    this.current = this.service.current;
    this.text = this.current.name;
    this.icon = this.current.icon;
  }


  onSelectionChanged = (e) => {
    // console.log(e.item);
    // this.current = e.item.value;
  }

  onItemClick(e: any) {
    const item = e.itemData;
    if (item.selectable) {
      this.text = item.name;
      this.icon = item.icon;
    }
    this.service.navigateTo(e.itemData);
  }
}
